module.exports = __webpack_public_path__ + "img/team-lars.d9373638.jpg";